import { isPlatformBrowser } from '@angular/common';
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
  name: 'setChatUsernames',
  standalone: true
})
export class SetChatUsernamesPipe implements PipeTransform {
  loggedUserId: any ;

  constructor(@Inject(PLATFORM_ID) private platformId: string){
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUserId = localStorage.getItem('tl-user') as any;
    }
  }

  transform(chat: any): any {
    if (chat) {
      if (!chat.is_group) {
        if (chat.other_participants !== undefined) {
          const otherParticipant = chat.other_participants.find((participant: any) => participant.id !== this.loggedUserId.id);
          return otherParticipant ? otherParticipant.username : '';
        }
      } else {
        if (chat.name) {
          const limitedParticipants = chat.name.length > 30
            ? `${chat.name.slice(0, 27)}...`
            : chat.name;
          return limitedParticipants;
        } else {
          const otherParticipants = chat.other_participants
            .filter((participant: any) => participant.id !== this.loggedUserId.id)
            .map((participant: any) => participant.username)
            .join(', ');

          const limitedParticipants = otherParticipants.length > 30
            ? `${otherParticipants.slice(0, 27)}...`
            : otherParticipants;

          return limitedParticipants;
        }
      }
    }
  }

}
